import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";

export function PayPalButton({ fixed = false, testid = "paypal-button" }) {
  const { t } = useApp();
  const [url, setUrl] = useState("");

  useEffect(() => {
    api.get("/config/paypal").then((r) => setUrl(r.data.url)).catch(() => {});
  }, []);

  const open = () => {
    if (url) window.open(url, "_blank", "noopener,noreferrer");
  };

  const btn = (
    <Button
      data-testid={testid}
      onClick={open}
      className="rounded-full bg-[#0070ba] px-8 py-6 text-base font-semibold text-white shadow-[0_8px_30px_rgba(0,112,186,0.25)] transition-transform hover:-translate-y-0.5 hover:bg-[#005ea6]"
    >
      {t("pay_paypal")}
    </Button>
  );

  if (fixed)
    return (
      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/90 p-4 backdrop-blur-xl">
        <div className="mx-auto flex max-w-5xl justify-center">{btn}</div>
      </div>
    );
  return btn;
}
